<template>
  <b-modal ref="saveReplyModal" centered size="lg" id="saveReply" title="Save Reply" hide-footer>
    <b-form class="text-left" @submit.stop.prevent="handleSubmit">
      <b-form-input v-model="reply.name" type="text" placeholder="Name"></b-form-input>
      <quill-editor  style="height: 220px" v-model="reply.content" ref="replyEditor" :options="editorOption"></quill-editor>
      <b-button variant="warning" type="submit">Save</b-button>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  name: 'SaveReplyTemplate',
  props: ['mailbox'],
  data () {
    return {
      reply: {
        name: '',
        content: ''
      },
      editorOption: {
        modules: {
        }
      }
    }
  },
  created () {
  },
  methods: {
    handleSubmit () {
      var vm = this
      var replyObject = this.reply
      this.$http.post('/mailboxes/' + vm.mailbox + '/saved_replies', {saved_reply: replyObject})
        .then(response => vm.submitSuccessful(response))
        .catch(e => { console.log(e.response) })
    },
    submitSuccessful () {
      this.$refs.saveReplyModal.hide()
    },
    showModal () {
      this.$refs.saveReplyModal.show()
    }
  },
  computed: {
    editor () {
      return this.$refs.replyEditor.quill
    }
  },
  mounted () {
    this.$root.$on('saveReply', (text) => {
      this.reply.content = text
      this.showModal()
    })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SaveReplyTemplate.vue